import { put, call, takeLatest, select } from 'redux-saga/effects';

import { getAdvocateAnalytics } from 'services/analytics';
import { AsyncAction } from 'types/Action';
import {
  GetAdvocateAnalyticsMeta,
  GetAdvocateAnalyticsPayload,
} from 'types/store/GetAdvocateAnalytics';
import { Store } from 'types/store/Store';

import { getAdvocateAnalyticsAction } from '../actions';

function* getAdvocateAnalyticsRequest(
  action: AsyncAction<GetAdvocateAnalyticsMeta, GetAdvocateAnalyticsPayload>
) {
  const state: Store = yield select();
  if (state.auth.token) {
    try {
      const { data } = yield call(
        getAdvocateAnalytics,
        action.meta,
        state.auth.token
      );
      yield put(getAdvocateAnalyticsAction.success(data));
    } catch (e: any) {
      yield put(getAdvocateAnalyticsAction.failed(e.message));
    }
  } else {
    yield put(getAdvocateAnalyticsAction.failed('Token not found'));
  }
}

function* getAdvocateAnalyticsSuccess(
  action: AsyncAction<GetAdvocateAnalyticsMeta, GetAdvocateAnalyticsPayload>
) {
  // yield put(push(EMPLOYER_ROUTES.LOGIN));
}

function* getAdvocateAnalyticsWatcher(): any {
  yield takeLatest(
    getAdvocateAnalyticsAction.REQUEST,
    getAdvocateAnalyticsRequest
  );
  yield takeLatest(
    getAdvocateAnalyticsAction.SUCCESS,
    getAdvocateAnalyticsSuccess
  );
}

export default getAdvocateAnalyticsWatcher;
